<template>
  <div class="client-list">
    <div class="animated fadeIn">
      <b-row class="pt-10">
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('customer.customer') }}</strong>
              <!--<div class="pull-right mr-4">-->
                <!--<button type="button" class="btn btn-success right" ><i class="fa fa-plus"></i>&nbsp; {{$t('common.new')}}</button>-->
              <!--</div>-->
            </div>
            <b-col cols="12" class="text-center">

              <!-- Start of Filter session -->
              <b-row>
                <b-col cols="10">
                  <b-input-group class="pull-right">
                    <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="filter.field" prefix="customer">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
                <b-col cols="2">
                  <div>
                    <b-input-group v-bind:prepend="$t('customer.status')">
                      <b-form-select v-model="filter.status" v-bind:value="filter.status" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('order-phil.status')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
                <!-- <b-col cols="1">
                  <button v-if="dataTable.items.length > 0" type="button" class="btn btn-primary" @click="exportData">
                    <span><i class="fa fa-download"></i> {{$t('common.export')}}</span>
                    </button>
                </b-col> -->
              </b-row>
              <b-form-checkbox
                v-if="dataTable.items.length > 0 && $store.getters.config.country_code == 'PE'"
                v-model="getDataUsageAcceptance"
                class="float-right my-2"
                plain
              >
                {{$t('customer.export_customer_data_usage')}}
              </b-form-checkbox>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive combo-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col" v-for="item in dataTable.fields" :key="item.id" v-show="checkShowByConfig(item.name)" @click="updateSort(item.name)" :class="item.sort?'pointer':''">
                      <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                      <span v-if="item.label != null">{{$t('customer.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('customer.'+item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 2">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id" v-show="checkShowByConfig(field.name)">
                      <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row" width="100">
                      <b-button size="sm" variant="primary" v-on:click="$router.push({name: 'customer_detail_list', params: { cid: item.id }})">
                        <i class="fa fa-address-book-o "></i>  {{$t('customer.details')}}
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->

            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import axios from 'axios'
import { ExportToCsv } from 'export-to-csv';
const CancelToken = axios.CancelToken
let cancel = null
let vm = null

export default {
  name: 'CustomerList',
  components: {
    SelectDropdown,
    DataTable
  },
  data: function () {
    return {
      useApiV4: false,
      basicInformationStatus: true,
      getDataUsageAcceptance: false,
      type: 'like',
      statuses: [],
      filter: {
        options: [],
        selected: null,
        active: '',
        status: '1',
        field: null,
        key: null
      },
      customer: this.$store.getters.config.gms.customer,
      dataTable: {
        items: [],
        fields: [
          {
            name: 'wos_id',
            filter: true,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'id',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'first_name',
            label: 'name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              if (this.$session.get('lang') == 'ja') {
                let name = data
                if (row.last_name != null && row.last_name != '') {
                  name = row.last_name + ' ' + name
                }
                return name
              }
              let name = data
              if (row.last_name != null && row.last_name != '') {
                name = row.last_name + ' ' + name
              }
              return name
            }
          },
          {
            name: 'local_first_name',
            label: 'local_name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              if (this.$session.get('lang') == 'ja') {
                let name = data
                if (row.local_last_name != null && row.local_last_name != '') {
                  name = row.local_last_name + ' ' + name
                }
                return name
              }
              let name = data
              if (row.local_last_name != null && row.local_last_name != '') {
                name = row.local_last_name + ' ' + name
              }
              return name
            }
          },
          {
            name: 'phone',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'emails',
            label: 'emails',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null || this._.isEmpty(data)) {
                return ''
              }
              let name = this._.map(data, 'email')
              return name.join(', ')
            }
          },
          {
            name: 'email',
            label: 'email',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null || this._.isEmpty(data)) {
                return ''
              }
              return data
            }
          },
          {
            name: 'membership',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              try {
                let lang = vm.$session.get('lang') == 'ja' ? 'ja' :  vm.$session.get('lang');
                let obj = JSON.parse(data.membership.name);
                return obj[lang]
              } catch(error) {
                return  data.membership ? data.membership.name : ''
              }
            }
          }
        ],
        sort: {
          field: 'id',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 10,
        source: null
      },
      item: {}
    }
  },
  methods: {
    checkShowByConfig (key) {
      if (this.customer == null) {
        return true
      }
      // console.log('BFS this.customer.list', this.customer.list)
      let config = this._.find(this.customer.list, function (o) {
        return o.type === key
      })
      if (config == null) {
        return false
      }
      return config.show
    },
    /**
     * update sort field and sort type then refresh data
     * @param field
     */
    updateSort (field) {
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },

    /**
     * refresh data for data table
     */
    refreshData () {
      if (cancel != null) {
        cancel()
      }
      // get params
      let _data = {
        page: this.dataTable.currentPage,
        limit: this.dataTable.perPage,
        sort_by: this.dataTable.sort.field,
        order_by: this.dataTable.sort.type
      }
      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        let mkey = this.filter.field.trim()
        if (mkey === 'first_name') {
          mkey = 'name'
        } else if (mkey === 'local_first_name') {
          mkey = 'local_name'
        }
        _data[mkey] = this.filter.key.trim()
      }

      if (this.filter.status != '') {
        _data['status'] = this.filter.status
      }

      // process to send via get method
      let params = ''
      for (let key in _data) {
        params += key + '=' + _data[key] + '&'
      }
      // remove tail
      params = params.slice(0, -1)
      vm.axios.customer.getCustomers(params, function (response) {
        vm.dataTable.items = response.data.data.items
        vm.dataTable.total = response.data.data.pagination.total
      }, () => {}, { useApiV4: this.useApiV4 })
    },
    editItem: function (uuid) {
    },
    setupQuery: async function(options){
      let search = "";

      const { filter, dataTable } = options;

      if (!this._.isEmpty(filter.field) && !this._.isEmpty(filter.key)) {
        search = "&"+ filter.field + "=" + filter.key.trim()
      }

      if (filter.status != '') {
        search = search + '&status=' + filter.status
      }
      let params = 'limit=' + dataTable.perPage + '&page=' + dataTable.currentPage + '&sort_by=' + dataTable.sort.field + '&order_by=' + dataTable.sort.type + search

      const resp = await this.axios.customer.getCustomersPromise(params, { useApiV4: this.useApiV4 });
      return resp
    },
    canExportCustomer(customer) {
      if (!!this.getDataUsageAcceptance && customer.receive_notification !== 1) {
        return false
      }
      return true
    },
    async exportData() {
      vm.$bus.$emit('loading', 'block')
      const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        filename: `customers_${this.$moment().format('YYYY-MM-DD')}`,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };

      const csvExporter = new ExportToCsv(options);

      let masterData = []
      const totalItems = this.dataTable.total
      const itemsPerPage = 10000; // maximum value allowed by ES

      for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
        const response = await this.setupQuery({
          dataTable: {
            ...this.dataTable,
            perPage: itemsPerPage,
            currentPage: i
          },
          filter: this.filter
        })

        const filteredResponse = response.data.data.items.filter(this.canExportCustomer)

        const data = filteredResponse.map( item => {
          const newItem = {};
          this.dataTable.fields.forEach( field => {
            if(field.render != null){
              const label = field.label ? this.$t('order.'+field.label) : this.$t('order.'+field.name)
              const val = field.render(item[field.name], item);

              newItem[label] = val
            }
          })
          return newItem;
        });

        masterData.push(...data)
      }
      if (masterData.length > 0) {
        csvExporter.generateCsv(masterData);
        this.$toastr.success(this.$t('message.export_success'), this.$t('message.success'), {})
      } else {
        this.$toastr.error(this.$t('message.export_no_data'), this.$t('message.save_fail'), {})
      }
      this.$bus.$emit('loading', 'none')
    }
  },
  created: function () {
    this.useApiV4 = this.$const.USE_CUSTOMER_API_V4.includes(String(localStorage.getItem('clientID')))
    // this.debouncedInput = _.debounce(this.refreshData, 240)
    vm = this
    let CancelToken = vm.axios.CancelToken
    vm.dataTable.source = CancelToken.source()
    let allowedFilter = ['id', 'first_name', 'phone', 'emails', 'local_first_name']
    if (this.checkShowByConfig('wos_id')) {
      allowedFilter.push('wos_id')
    }
    if (vm.$store.getters.config.country_code === 'PE') {
      vm.dataTable.fields = vm.dataTable.fields.filter(f => ['emails', 'local_first_name', 'membership'].every(s => f.name != s))
      vm.dataTable.fields.push({
        name: 'receive_notification',
        label: vm.$t('customer.data_usage_acceptance'),
        filter: false,
        sort: false,
        render: (_, row) => row.receive_notification ? vm.$t('common.yes') : vm.$t('common.no')
      })
      vm.dataTable.fields.push({
        name: 'created_at',
        label: vm.$t('customer.created_at'),
        filter: false,
        sort: false,
        render: (_, row) => row.created_at
      })
      vm.customer.list.push({type: 'receive_notification', show: true})
      vm.customer.list.push({type: 'created_at', show: true})
    }

    for (let i in vm.dataTable.fields) {
      let field = vm.dataTable.fields[i].name

      if (allowedFilter.includes(vm.dataTable.fields[i].name) &&
          vm.dataTable.fields[i].filter != null &&
          vm.dataTable.fields[i].filter == true) {
        vm.filter.options.push(vm.dataTable.fields[i])
      }
      if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true && vm.dataTable.sort.field == null) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      }
    }
    vm.$Progress.start()
    let filter = this.$session.get('filter', null)
    if (filter != null && this.$route.query && this.$route.query.rollback) {
      for (let i in filter.filter) {
        this.filter[i] = filter.filter[i]
      }
      for (let i in filter.dataTable) {
        this.dataTable[i] = filter.dataTable[i]
      }
    }
    vm.refreshData()
  },
  mounted() {
    let langs = vm.$store.getters.languages
    for (let l in langs) {
      vm.statuses[langs[l]] = [
        // {text: vm.$t('common.all', langs[l]), value: ''},
        {text: vm.$t('common.active', langs[l]), value: '1'},
        {text: vm.$t('common.inactive', langs[l]), value: '0'}
      ]
    }
  },
  beforeDestroy: function () {
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'filter.key': function (val) {
      // this.debouncedInput()
    },
    'filter.status': function (val) {
      // vm.refreshData()
    },
    'dataTable.currentPage': function (val) {
      vm.refreshData()
    },
    'dataTable.perPage': function (val) {
      vm.refreshData()
    }
  }
}
</script>
<style scoped>
  .text-green {
    color: green;
  }
  .text-red {
    color: red;
  }
  .pt-10{
    padding-top: 10px;
  }
  .min-width-13 {
    min-height: 26px;
    min-width: 28px;
    border-radius: 4px;
  }
  table tr th:nth-child(1) {
    width: 130px;
  }
  table tr th:nth-child(2) {
    width: 200px;
  }
  table tr th:nth-child(3) {
    width: 200px;
  }
  table tr th:nth-child(4) {
    width: 200px;
  }
  table tr th:nth-child(6) {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/customer/List.vue